class ComponentBtnBackTop {
  private btn: HTMLButtonElement | null = null;
  private scrollTicking: boolean = false;
  private scrollThreshold: number = 0;
  constructor() {
    this._handleScroll = this._handleScroll.bind(this);
    this._scrollToTop = this._scrollToTop.bind(this);

    this._init();
  }

  _init() {
    this.btn = document.querySelector('[data-btn-back-top]');
    if (!this.btn) return;

    this.scrollTicking = false;
    this.scrollThreshold = window.innerHeight * 0.8;

    this._setupClickListener();
    this._setupScrollListener();
  }

  _setupClickListener() {
    this.btn?.addEventListener('click', this._scrollToTop, false);
  }

  _scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  _setupScrollListener() {
    window.addEventListener('scroll', () => {
      if (!this.scrollTicking) {
        window.requestAnimationFrame(() => {
          this._handleScroll();
          this.scrollTicking = false;
        });
        this.scrollTicking = true;
      }
    });
  }

  _handleScroll() {
    if (window.scrollY > this.scrollThreshold) {
      this.btn?.classList.add('visible');
    } else {
      this.btn?.classList.remove('visible');
    }
  }
}

export const componentBtnBackTop = new ComponentBtnBackTop();